import React, { useState, useEffect, useRef, useCallback } from 'react'

import PowerDeckRow from './PowerDeckRow'

import { client, session } from '../../../utils/nakama';

import "./PowerDeckContainer.css";
import BootstrapToast from '../../../components/BootstrapToast';
import infoIcon from '../../../assets/images/info_icon.png'
import { playSound, handleClickSound } from "../../game/scenes/classes/PlaySound";


function PowerDeckContainer({ droppedItems, isDropped, dropIndicator, cardCollection, setCardCollection, setRefreshCardCollectionTrigger, cardSlots, setCardSlots }) {
  // this object holds the raw data format for the power deck that will be sent to and retrieved from power_deck storage object
  // which takes the form of an array of card names
  // const [nakamaDeck, setNakamaDeck] = useState([]);
  // const [deckLoaded, _setDeckLoaded] = useState(false);
  // const [cardSlots, _setCardSlots] = useState([])
  const [showToast, setShowToast] = useState(false);
  const [toastType, setToastType] = useState("success");
  const [toastText, setToastText] = useState("");

  const filteredCards = new Set([
    'plus_1', 'plus_2', 'plus_3', 'plus_4', 'plus_5', 'plus_6',
    'neg_1', 'neg_2', 'neg_3', 'neg_4', 'neg_5', 'neg_6',
    'plus_neg_1', 'plus_neg_2', 'plus_neg_3', 'plus_neg_4', 'plus_neg_5', 'plus_neg_6'
  ]);

  //update the card count (/10)
  const [cardCount, setCardCount] = useState(0);
  const cardCountRef = useRef(cardCount);
  const setCardCountRef = (update) => {
    cardCountRef.current = update;
    setCardCount(update);
  }
  useEffect(() => {
    if (cardSlots) {
      let count = 0;
      cardSlots.map((slot) => {
        if (slot.image !== "") {
          count += slot.count;
        }
      })
      setCardCountRef(count);
      // console.log("powerdeck container card count: ", cardCount, dropIndicator);
    }
  }, [cardSlots, cardCount]);

  //UPDATE SERVER SIDE POWER DECK
  const updateServerPowerDeck = (async (newCardSlots, cardName, type, displayToast = true) => {
    var nakamaDeck = { housePowerCards: new Map(), nftPowerCards: new Map() };
    for (var i = 0; i < newCardSlots.length; i++) {
        if (filteredCards.has(newCardSlots[i].image) && newCardSlots[i].image.toString() !== "") {
            nakamaDeck.housePowerCards.set(newCardSlots[i].image.toString(), newCardSlots[i].count);
        } else if (newCardSlots[i].image.toString() !== "") {
            nakamaDeck.nftPowerCards.set(newCardSlots[i].image.toString(), newCardSlots[i].count);
        }
    }

    try {

      //console.log("updating power deck", nakamaDeck);
      //console.log("cardName", cardName);
      //console.log("type", type);
      const response = await client.rpc(session, "updatePowerDeck", {
        housePowerCards: Array.from(nakamaDeck.housePowerCards), //convert map to array for transmission
        nftPowerCards: Array.from(nakamaDeck.nftPowerCards),
        cardName: cardName,
        type: type,
      });

    

      if (response.payload.message === "success" && displayToast) {
        setShowToast(true);
        setToastText("Deck Saved");
        setToastType("success");
      }
      else {
        if (displayToast) {
          setShowToast(true);
          setToastText(`error with saving deck: ${response.payload.message}`);
          setToastType("danger");
          //handleDrop({ cardName: cardName, houseCard: newCardSlots[droppedPos].houseCard }, false); //re-add card to deck
          //handleRemove(item.cardName, false); //remove card from deck
          setRefreshCardCollectionTrigger(true); //trigger to refresh card collection
        }
      }
    } catch (err) {
      if (displayToast) {
        setShowToast(true);
        setToastText(`error with saving deck: ${err}`);
        setToastType("danger");
        //handleDrop({ cardName: cardName, houseCard: newCardSlots[droppedPos].houseCard }, false); //re-add card to deck
        //handleRemove(item.cardName, false); //remove card from deck
        setRefreshCardCollectionTrigger(true); //trigger to refresh card collection
      }
    }
  });

  const handleRemove = async (cardName, displayToast = true) => {
    console.log('Card removed from deck', cardName);

    setCardCountRef(cardCount - 1);

    // Find the index of the card to remove from droppedItems
    const droppedItemPos = droppedItems.findIndex((item) => item.toString() === cardName.toString());

    // Find the index of the card in cardSlots
    const droppedPos = cardSlots.findIndex((slot) => slot.image.toString() === cardName.toString());

    if (droppedItemPos !== -1) {
      // Remove the card from droppedItems
      droppedItems.splice(droppedItemPos, 1);
    }
    if (droppedPos !== -1) {
      //UPDATE CARD SLOTS
      let decrementFlag = false;
      setCardSlots(prevCardSlots => {
        // Create a new copy of cardSlots
        const newCardSlots = [...prevCardSlots];

        // Remove one instance of the card from cardSlots
        if (!decrementFlag && newCardSlots[droppedPos].count === 1) {
          // Push all cards up to make up for the lost space
          for (let i = droppedPos; i < newCardSlots.length - 1; i++) {
            newCardSlots[i].count = newCardSlots[i + 1].count;
            newCardSlots[i].image = newCardSlots[i + 1].image;
          }
          newCardSlots[newCardSlots.length - 1].image = '';
          newCardSlots[newCardSlots.length - 1].count = 0;

          decrementFlag = true;
        } else if (!decrementFlag && newCardSlots[droppedPos].count > 1) {
          newCardSlots[droppedPos].count--;
          decrementFlag = true;
        }

        updateServerPowerDeck(newCardSlots, cardName, 'remove');
        return newCardSlots; // Return the updated copy
      })

      //UPDATE CARD COLLECTION
      let incrementFlag = false;
      setCardCollection(prevCardCollection => {
        // Create a new copy of cardCollection
        const newCollection = { ...prevCardCollection };

        if (!incrementFlag && newCollection.housePowerCards.has(cardName)) {
          newCollection.housePowerCards.set(cardName, prevCardCollection.housePowerCards.get(cardName) + 1);
          incrementFlag = true;
        }
        else if (!incrementFlag && newCollection.nftPowerCards.has(cardName)) {
          newCollection.nftPowerCards.set(cardName, prevCardCollection.nftPowerCards.get(cardName) + 1);
          incrementFlag = true;
        }

        return newCollection; // Return the updated copy
      });
    }
  }

  const handleDrop = async (item, displayToast = true) => {
    console.log('Card added to deck', item);

    setCardSlots(prevCardSlots => {
      const newCardSlots = [...prevCardSlots]; // Create a new copy of cardSlots

      if (cardCountRef.current < 11) {
        for (var i = 0; i < newCardSlots.length; i++) {
          if (newCardSlots[i].image.toString() === item.cardName.toString()) {
            newCardSlots[i].count++;
            droppedItems.push(item.cardName);
            break;
          }
          else if (newCardSlots[i].image.toString() === "") {
            newCardSlots[i] = {
              image: item.cardName,
              count: 1,
            }
            droppedItems.push(item.cardName);
            break;
          }
        }
      }

      updateServerPowerDeck(newCardSlots, item.cardName, 'add');
      return newCardSlots; // Return the updated copy
    })

    //updating card collection
    let decrementFlag = false;
    setCardCollection(prevCardCollection => { //WARN: this function is called TWICE with React Strictmode. Do not modify references
      // Create a new copy of cardCollection
      const newCollection = { ...prevCardCollection };

      if (!decrementFlag && newCollection.housePowerCards.has(item.cardName)) {
        newCollection.housePowerCards.set(item.cardName, prevCardCollection.housePowerCards.get(item.cardName) - 1);
        decrementFlag = true;
      }
      else if (!decrementFlag && newCollection.nftPowerCards.has(item.cardName)) {
        newCollection.nftPowerCards.set(item.cardName, prevCardCollection.nftPowerCards.get(item.cardName) - 1);
        decrementFlag = true;
      }

      return newCollection; // Return the updated copy
    });
  }

  return (
    <>

      <div
        className="whole-container"
        style={{ textAlign: 'left', backgroundColor: 'rgba(22, 27, 47, 0.7)', maxHeight: "760px" }}
      >
        <h1 className="container-title drop-indicator " style={{ pointerEvents: "none" }}>

          {
            dropIndicator && cardCountRef.current < 11 && "Drop Here"}
        </h1>
        <div className={`${dropIndicator && cardCountRef.current < 11 && `drag-blur`}`}>

          <div style={{ display: "flex", paddingBottom: "2%" }}>
            <h1 className="container-title pink-text" style={{ display: 'inline' }}>Power Deck</h1>
            <h1
              className="container-subtitle light-blue-text"
              style={{ display: 'inline', marginRight: "0", marginTop: "3%", marginLeft: "auto" }}
            >
              {cardCountRef.current}/10
            </h1>
          </div>

          {Array.isArray(cardSlots) && cardSlots.map((card, index) => (
            <PowerDeckRow
              onDrop={(item) => { handleDrop(item, index) }}
              handleRemove={handleRemove}
              name={card.name}
              index={index}
              alt={index % 2 === 0}
              image={card.image}
              count={card.count}
              key={index}
              droppable={cardCountRef.current < 11}
            />
          ))}
        </div>
        <BootstrapToast position={'bottom-start'} visible={showToast} background={toastType} setShowToast={setShowToast} text={toastText} />
      </div>
    </>
  )
}

export default PowerDeckContainer